<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    max-width="960"
    scrollable
    class="budget-suga-info-dialog-wrap"
  >
    <v-card class="budget-suga-info-card">
      <v-card-title class="budget-suga-info-card__title">
        <span class="budget-admin-badge">관리자전용</span>
        <v-icon size="22" color="#1e3a5f" class="mr-2">mdi-table-edit</v-icon>
        <span>수가 정보 (사업·연도별 구간)</span>
        <button type="button" class="dialog-close-x" title="닫기" @click="close">
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </v-card-title>
      <v-card-text class="budget-suga-info-card__body">
        <div class="budget-suga-info-toolbar">
          <div class="budget-suga-info-toolbar__row">
            <label class="budget-suga-info-label">편집 연도</label>
            <v-select
              v-model="editYear"
              :items="yearItems"
              density="compact"
              variant="outlined"
              hide-details
              class="budget-suga-info-field budget-suga-info-field--year"
              @update:model-value="loadList"
            />
            <v-btn variant="flat" class="btn-refresh" :loading="loading" @click="loadList">새로고침</v-btn>
          </div>
          <div class="budget-suga-info-toolbar__row budget-suga-info-toolbar__row--copy">
            <span class="budget-suga-info-copy-label">다음 연도 틀 복사 (급여·본인부담 0)</span>
            <v-select
              v-model="copyFromYear"
              :items="yearItems"
              density="compact"
              variant="outlined"
              hide-details
              placeholder="원본 연도"
              class="budget-suga-info-field budget-suga-info-field--sm"
            />
            <span class="budget-suga-info-arrow">→</span>
            <v-text-field
              v-model.number="copyToYear"
              type="number"
              density="compact"
              variant="outlined"
              hide-details
              class="budget-suga-info-field budget-suga-info-field--xs"
            />
            <v-btn variant="flat" class="btn-confirm" :loading="copying" @click="doCopyYear">복사</v-btn>
          </div>
        </div>

        <div class="budget-suga-info-table-wrap">
          <table class="budget-suga-info-table">
            <thead>
              <tr>
                <th>사업구분</th>
                <th>구간</th>
                <th>사용</th>
                <th>기초</th>
                <th>급여총액</th>
                <th>본인부담</th>
                <th>순서</th>
                <th class="budget-suga-info-table__actions">관리</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!loading && rows.length === 0">
                <td colspan="8" class="budget-suga-info-table__empty">데이터가 없습니다.</td>
              </tr>
              <tr v-for="r in rows" :key="r.csi_idx">
                <td>{{ r.csi_biz_gubun }}</td>
                <td>{{ r.csi_rank }}</td>
                <td>{{ r.csi_is_use }}</td>
                <td>{{ r.csi_basis_yn }}</td>
                <td class="tar">{{ formatNum(r.csi_gross_fee) }}</td>
                <td class="tar">{{ formatNum(r.csi_copay_fee) }}</td>
                <td class="tar">{{ r.csi_sort }}</td>
                <td class="budget-suga-info-table__actions">
                  <v-btn icon size="x-small" variant="text" color="primary" @click="openEdit(r)">
                    <v-icon size="18">mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon size="x-small" variant="text" color="error" @click="confirmDelete(r)">
                    <v-icon size="18">mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="budget-suga-info-add">
          <v-btn variant="flat" class="btn-register" @click="openAdd">행 추가</v-btn>
        </div>
      </v-card-text>
      <v-card-actions class="budget-suga-info-card__actions">
        <v-spacer />
        <v-btn variant="text" class="btn-close" @click="close">닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="formOpen" class="budget-suga-info-form-dialog" max-width="480">
    <v-card>
      <v-card-title class="budget-suga-info-form-title">
        <span class="budget-admin-badge">관리자전용</span>
        {{ formMode === 'add' ? '행 추가' : '행 수정' }}
        <button type="button" class="dialog-close-x" title="닫기" @click="formOpen = false">
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </v-card-title>
      <v-card-text class="budget-suga-info-form-body">
        <v-select
          v-model="form.bizGubun"
          :items="bizOptions"
          label="사업구분"
          density="compact"
          variant="outlined"
          hide-details
          class="budget-suga-info-form-field"
        />
        <v-text-field
          v-model.number="form.year"
          label="연도"
          type="number"
          density="compact"
          variant="outlined"
          hide-details
          class="budget-suga-info-form-field"
        />
        <v-text-field
          v-model="form.rank"
          label="구간(등급)"
          density="compact"
          variant="outlined"
          hide-details
          class="budget-suga-info-form-field"
        />
        <v-select
          v-model="form.isUse"
          :items="['Y', 'N']"
          label="사용"
          density="compact"
          variant="outlined"
          hide-details
          class="budget-suga-info-form-field"
        />
        <v-select
          v-model="form.basisYn"
          :items="['Y', 'N']"
          label="기초"
          density="compact"
          variant="outlined"
          hide-details
          class="budget-suga-info-form-field"
        />
        <v-text-field
          v-model="form.grossFee"
          label="급여 총액(장기요양급여)"
          density="compact"
          variant="outlined"
          hide-details
          class="budget-suga-info-form-field"
        />
        <v-text-field
          v-model="form.copayFee"
          label="본인부담"
          density="compact"
          variant="outlined"
          hide-details
          class="budget-suga-info-form-field"
        />
        <v-text-field
          v-model.number="form.sort"
          label="정렬(작을수록 위)"
          type="number"
          density="compact"
          variant="outlined"
          hide-details
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" class="btn-cancel" @click="formOpen = false">취소</v-btn>
        <v-btn variant="flat" class="btn-save" :loading="formSaving" @click="submitForm">저장</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { budgetApi } from "@/services/api";

export interface SugaInfoRow {
  csi_idx: number;
  csi_biz_gubun: string;
  csi_year: number;
  csi_is_use: string;
  csi_rank: string;
  csi_basis_yn: string;
  csi_gross_fee: number;
  csi_copay_fee: number;
  csi_sort: number;
}

const props = defineProps<{
  modelValue: boolean;
  panelYear: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", v: boolean): void;
  (e: "saved"): void;
}>();

const bizOptions = [
  "요양시설",
  "공동생활가정",
  "주야간보호",
  "방문요양",
  "방문목욕",
  "방문간호",
  "복지용구",
];

const loading = ref(false);
const copying = ref(false);
const rows = ref<SugaInfoRow[]>([]);
const yearsFromApi = ref<number[]>([]);
const editYear = ref<number>(parseInt(props.panelYear, 10) || new Date().getFullYear());
const copyFromYear = ref<number | null>(null);
const copyToYear = ref<number>((parseInt(props.panelYear, 10) || new Date().getFullYear()) + 1);

const yearItems = computed(() => {
  const set = new Set<number>(yearsFromApi.value);
  const py = parseInt(props.panelYear, 10);
  if (!Number.isNaN(py)) set.add(py);
  set.add(editYear.value);
  return Array.from(set).sort((a, b) => b - a);
});

const formOpen = ref(false);
const formMode = ref<"add" | "edit">("add");
const formSaving = ref(false);
const editingIdx = ref<number | null>(null);
const form = ref({
  bizGubun: "",
  year: editYear.value,
  rank: "",
  isUse: "Y" as "Y" | "N",
  basisYn: "N" as "Y" | "N",
  grossFee: "",
  copayFee: "",
  sort: 10,
});

function close() {
  emit("update:modelValue", false);
}

function formatNum(n: number) {
  return Number(n || 0).toLocaleString();
}

async function loadYears() {
  try {
    const res = await budgetApi.getSugaInfoYears();
    const d = res.data as { success?: boolean; data?: number[] };
    if (d?.success && Array.isArray(d.data)) {
      yearsFromApi.value = d.data.map((x) => Number(x));
    }
  } catch {
    yearsFromApi.value = [];
  }
}

async function loadList() {
  loading.value = true;
  try {
    const res = await budgetApi.getSugaInfoList({ year: editYear.value });
    const d = res.data as { success?: boolean; data?: SugaInfoRow[] };
    rows.value = d?.success && Array.isArray(d.data) ? d.data : [];
  } catch (e: unknown) {
    const err = e as { response?: { data?: { message?: string } } };
    alert(err.response?.data?.message || "목록을 불러오지 못했습니다.");
    rows.value = [];
  } finally {
    loading.value = false;
  }
}

async function doCopyYear() {
  const fy = copyFromYear.value;
  const ty = Number(copyToYear.value);
  if (fy == null || Number.isNaN(ty)) {
    alert("원본 연도와 대상 연도를 입력하세요.");
    return;
  }
  if (!confirm(`${fy}년 틀을 ${ty}년으로 복사합니다. 급여·본인부담은 0으로 둡니다. 계속할까요?`)) return;
  copying.value = true;
  try {
    const res = await budgetApi.copySugaInfoYear({ fromYear: fy, toYear: ty });
    const d = res.data as { success?: boolean; message?: string; inserted?: number };
    if (d?.success) {
      await loadYears();
      editYear.value = ty;
      await loadList();
      emit("saved");
      alert(`${d.inserted ?? 0}건 복사되었습니다.`);
    } else {
      alert(d?.message || "복사에 실패했습니다.");
    }
  } catch (e: unknown) {
    const err = e as { response?: { data?: { message?: string }; status?: number } };
    alert(err.response?.data?.message || "복사 중 오류가 발생했습니다.");
  } finally {
    copying.value = false;
  }
}

function openAdd() {
  formMode.value = "add";
  editingIdx.value = null;
  form.value = {
    bizGubun: bizOptions[0],
    year: editYear.value,
    rank: "",
    isUse: "Y",
    basisYn: "N",
    grossFee: "",
    copayFee: "",
    sort: 10,
  };
  formOpen.value = true;
}

function openEdit(r: SugaInfoRow) {
  formMode.value = "edit";
  editingIdx.value = r.csi_idx;
  form.value = {
    bizGubun: r.csi_biz_gubun,
    year: r.csi_year,
    rank: r.csi_rank,
    isUse: r.csi_is_use === "N" ? "N" : "Y",
    basisYn: r.csi_basis_yn === "Y" ? "Y" : "N",
    grossFee: String(r.csi_gross_fee ?? ""),
    copayFee: String(r.csi_copay_fee ?? ""),
    sort: r.csi_sort,
  };
  formOpen.value = true;
}

async function submitForm() {
  formSaving.value = true;
  try {
    if (formMode.value === "add") {
      const res = await budgetApi.postSugaInfo({
        bizGubun: form.value.bizGubun,
        year: form.value.year,
        rank: form.value.rank,
        isUse: form.value.isUse,
        basisYn: form.value.basisYn,
        grossFee: form.value.grossFee,
        copayFee: form.value.copayFee,
        sort: form.value.sort,
      });
      const d = res.data as { success?: boolean; message?: string };
      if (!d?.success) {
        alert(d?.message || "저장 실패");
        return;
      }
    } else if (editingIdx.value != null) {
      const res = await budgetApi.patchSugaInfo(editingIdx.value, {
        bizGubun: form.value.bizGubun,
        year: form.value.year,
        rank: form.value.rank,
        isUse: form.value.isUse,
        basisYn: form.value.basisYn,
        grossFee: form.value.grossFee,
        copayFee: form.value.copayFee,
        sort: form.value.sort,
      });
      const d = res.data as { success?: boolean; message?: string };
      if (!d?.success) {
        alert(d?.message || "수정 실패");
        return;
      }
    }
    formOpen.value = false;
    await loadYears();
    await loadList();
    emit("saved");
  } catch (e: unknown) {
    const err = e as { response?: { data?: { message?: string } } };
    alert(err.response?.data?.message || "저장 중 오류");
  } finally {
    formSaving.value = false;
  }
}

async function confirmDelete(r: SugaInfoRow) {
  if (!confirm(`삭제할까요?\n${r.csi_biz_gubun} / ${r.csi_rank}`)) return;
  try {
    const res = await budgetApi.deleteSugaInfo(r.csi_idx);
    const d = res.data as { success?: boolean; message?: string };
    if (!d?.success) {
      alert(d?.message || "삭제 실패");
      return;
    }
    await loadList();
    emit("saved");
  } catch (e: unknown) {
    const err = e as { response?: { data?: { message?: string } } };
    alert(err.response?.data?.message || "삭제 중 오류");
  }
}

watch(
  () => props.modelValue,
  async (open) => {
    if (!open) {
      formOpen.value = false;
      return;
    }
    const py = parseInt(props.panelYear, 10);
    if (!Number.isNaN(py)) editYear.value = py;
    await loadYears();
    if (copyFromYear.value == null && yearItems.value.length) {
      copyFromYear.value = yearItems.value[0];
    }
    await loadList();
  }
);

watch(
  () => props.panelYear,
  (y) => {
    const n = parseInt(y, 10);
    if (!Number.isNaN(n) && props.modelValue) {
      editYear.value = n;
      loadList();
    }
  }
);
</script>
